<script>
export default {
    name: 'IconFacebook',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-facebook"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M41.603 13.297h5.272V4.394C45.967 4.274 42.839 4 39.197 4c-7.602 0-12.808 4.637-12.808 13.158V25H18v9.953h8.39V60h10.28V34.953h8.05L46 25h-9.33v-6.858c0-2.876.799-4.845 4.933-4.845z"
        />
    </svg>
</template>
